// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/order_item_requests/salvar
 *
 * Returns the persisted request id (`{so_oir_id: int}`) for both
 * create (insert_id) and update (echoes the input id) paths.
 *
 * @see So_order_item_requests_model::create()
 * @see So_order_item_requests_model::updateRequest()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Order_item_requests_SalvarResponseDados {
so_oir_id: number
}

export type Order_item_requests_SalvarResponse = ApiResponse<Order_item_requests_SalvarResponseDados>;

registerResponseContract('Order_item_requests_SalvarResponse', {
  so_oir_id: { type: 'number',  required: true },
})
